import AxisLogo from "./axis-icon.svg";
import HDFCLogo from "./hdfc-icon.png";
import ICICILogo from "./icici-icon.svg";
import SBILogo from "./sbi-icon.svg";

const banks = [
  { code: "1003", label: "Axis Bank" },
  { code: "1075", label: "Bank of Baroda Net Banking Corporate" },
  { code: "1076", label: "Bank of Baroda Net Banking Retail" },
  { code: "1012", label: "Bank of India" },
  { code: "1033", label: "Bank of Maharashtra" },
  { code: "1030", label: "Canara Bank NetBanking" },
  { code: "1028", label: "Central Bank of India" },
  { code: "1020", label: "City Union Bank" },
  { code: "1031", label: "CSB Bank" },
  { code: "1047", label: "DBS Bank Ltd" },
  { code: "1027", label: "DCB Bank" },
  { code: "1024", label: "Deutsche Bank" },
  { code: "1038", label: "Dhanlaxmi Bank" },
  { code: "1063", label: "Equitas Bank" },
  { code: "1019", label: "Federal Bank" },
  { code: "1006", label: "HDFC Bank" },
  { code: "1002", label: "ICICI Bank" },
  { code: "1007", label: "IDBI Bank" },
  { code: "1073", label: "IDFC FIRST Bank Limited" },
  { code: "1026", label: "Indian Bank" },
  { code: "1029", label: "Indian Overseas Bank" },
  { code: "1015", label: "Indusind Bank" },
  { code: "1001", label: "Jammu and Kashmir Bank" },
  { code: "1072", label: "Janata Sahakari Bank Limited" },
  { code: "1008", label: "Karnataka Bank" },
  { code: "1018", label: "Karur Vysya Bank" },
  { code: "1013", label: "Kotak Mahindra Bank" },
  { code: "1055", label: "Punjab & Sind Bank" },
  { code: "1077", label: "Punjab National Bank - Corporate" },
  { code: "1049", label: "Punjab National Bank [Retail]" },
  { code: "1066", label: "RBL Bank" },
  { code: "1050", label: "Royal Bank Of Scotland" },
  { code: "1051", label: "Standard Chartered Bank" },
  { code: "1014", label: "State Bank of India" },
  { code: "1044", label: "Tamilnad Mercantile Bank" },
  { code: "1057", label: "UCO Bank" },
  { code: "1016", label: "Union Bank of India - Retail" },
  { code: "1005", label: "Yes Bank" },
  { code: "1097", label: "Airtel Payments Bank" },
  { code: "1037", label: "American Express" },
  { code: "1090", label: "AU Small Finance Bank Net Banking" },
  { code: "1088", label: "Bandhan Bank" },
  { code: "1096", label: "Bank of Bahrain and Kuwait" },
  { code: "2032", label: "Capital Small Finance Bank" },
  { code: "1092", label: "Cosmos Bank" },
  { code: "1093", label: "HSBC Bank" },
  { code: "1078", label: "ICICI Bank - Corporate" },
  { code: "1087", label: "Jana Small Finance Bank" },
  { code: "2037", label: "Nainital Bank" },
  { code: "1095", label: "NKGSB Co-op Bank Ltd" },
  { code: "156", label: "RBL Bank Corporate" },
  { code: "1053", label: "Saraswat Bank" },
  { code: "1091", label: "Shamrao Vithal Co-op. Bank Ltd" },
  { code: "1022", label: "South Indian Bank" },
  { code: "1098", label: "Suryoday Small Finance Bank Ltd" },
  { code: "1094", label: "Syndicate Bank" },
  { code: "1089", label: "Ujjivan Small Finance Bank" }
];

export default {
  popular: () => {
    return [
      { icon: SBILogo, label: "SBI", code: "1014" },
      { icon: HDFCLogo, label: "HDFC", code: "1006" },
      { icon: ICICILogo, label: "ICICI", code: "1002" },
      { icon: AxisLogo, label: "Axis", code: "1003" }
    ];
  },

  all: () => {
    return banks;
  },

  search: term => {
    const inputValue = term.trim().toLowerCase();
    if (inputValue.length === 0) return banks;

    const startsWith = [];
    const contains = [];
    const rest = [];
    banks.forEach(bank => {
      const label = bank.label.toLowerCase();
      if (label.startsWith(inputValue)) {
        startsWith.push(bank);
      } else if (label.indexOf(inputValue) !== -1) {
        contains.push(bank);
      } else {
        rest.push(bank);
      }
    });

    return startsWith.concat(contains).concat(rest);
  }
};
